export default __webpack_public_path__ + "static/media/12-6.6aed4213.png";